import CaptionsThumbnail2 from "../../assets/project-media/captions-2.png";
import CaptionsThumbnail3 from "../../assets/project-media/captions-3.png";
import CaptionsThumbnail4 from "../../assets/project-media/captions-4.png";
import CaptionsThumbnail5 from "../../assets/project-media/captions-5.png";
import CaptionsDemo2 from "../../assets/project-media/captions-demo-2.mp4";
import CaptionsDemo3 from "../../assets/project-media/captions-demo-3.mp4";
import CaptionsDemo from "../../assets/project-media/captions-demo.mp4";
import CaptionsThumbnail from "../../assets/project-media/captions.png";
import CovidCoveThumbnail from "../../assets/project-media/covid-cove.jpg";
import EasyConveyThumbnail2 from "../../assets/project-media/easy-convey-2.png";
import EasyConveyThumbnail3 from "../../assets/project-media/easy-convey-3.png";
import EasyConveyThumbnail4 from "../../assets/project-media/easy-convey-4.png";
import EasyConveyThumbnail5 from "../../assets/project-media/easy-convey-5.png";
import EasyConveyThumbnail6 from "../../assets/project-media/easy-convey-6.png";
import EasyConveyThumbnail7 from "../../assets/project-media/easy-convey-7.png";
import EasyConveyThumbnail from "../../assets/project-media/easy-convey.png";
import ReplstashDemo from "../../assets/project-media/replstash-2.gif";
import ReplstashDemo2 from "../../assets/project-media/replstash-3.gif";
import ReplstashThumbnail from "../../assets/project-media/replstash.png";
import ReplstashThumbnail2 from "../../assets/project-media/replstash-4.png";
import ReplstashThumbnail3 from "../../assets/project-media/replstash-5.png";
import ReplstashThumbnail4 from "../../assets/project-media/replstash-7.png";
import ReplstashThumbnail5 from "../../assets/project-media/replstash-8.png";
import ReplstashThumbnail6 from "../../assets/project-media/replstash-9.png";
import MMAThumbnail from "../../assets/project-media/mma-api.png";
import PodsortLanding from "../../assets/project-media/podsort-1-landing.png";
import PodsortFeatures from "../../assets/project-media/podsort-2-features.png";
import PodsortHowItWorks from "../../assets/project-media/podsort-3-how-it-works.png";
import PodsortFaq from "../../assets/project-media/podsort-4-faq.png";
import PodsortBeta from "../../assets/project-media/podsort-5-beta.png";
import PodsortSearch from "../../assets/project-media/podsort-6-search.png";
import PodsortFilter from "../../assets/project-media/podsort-7-filter.png";
import PodsortCluster from "../../assets/project-media/podsort-8-cluster.png";

export const webApps = [
  {
    title: "Podsort",
    image: PodsortLanding,
    technologies: "React | TypeScript | Node.js | Spotify API | PostgreSQL",
    description:
      "A semantic podcast search and playlist curation tool. Discover episodes by meaning, not just keywords. Filter by duration, date range, and explicit content. Episodes are auto-clustered by topic, with drag-and-drop reordering and one-click export to Spotify playlists.",
    projectMedia: [
      PodsortLanding,
      PodsortFeatures,
      PodsortHowItWorks,
      PodsortSearch,
      PodsortFilter,
      PodsortCluster,
      PodsortFaq,
      PodsortBeta,
    ],
    deployed: "https://podsort.app",
    bgcolor: "rgba(255, 255, 255, 0.75)",
    id: "1",
  },
  {
    title: "Easy Convey Legal Docs",
    image: EasyConveyThumbnail,
    technologies: "NodeJS | React | MySQL | NGINX | Docker | Redis",
    description:
      "A law and calendar based web application created as part of my Software Engineering capstone used to parse, generate, store and send various types of legal documents for contracts, titles deeds taxes and more.",
    projectMedia: [
      EasyConveyThumbnail,
      EasyConveyThumbnail2,
      EasyConveyThumbnail3,
      EasyConveyThumbnail4,
      EasyConveyThumbnail5,
      EasyConveyThumbnail6,
      EasyConveyThumbnail7,
    ],
    bgcolor: "rgba(255, 255, 255, 0.75)",
    id: "2",
  },
  {
    title: "CovidCove Stats Dashboard",
    image: CovidCoveThumbnail,
    technologies: "Django | SQL | Python | Docker",
    description:
      "A dashboard web application that gathered live data throughout COVID-19 to display up to date charting information and visualizations on the virus such as recovery vs fatality rates, areas most affected and vacination rates. This was done through integration with various APIs and data sources.\n",
    projectMedia: [CovidCoveThumbnail],
    source: "https://github.com/FelixVaughan/CovidCove",
    bgcolor: "rgba(255, 255, 255, 0.75)",
    id: "3",
  },
];

export const backendProjects = [
  {
    title: "Mixed Martial Arts API",
    image: MMAThumbnail,
    technologies: "NodeJS | Docker | Bash | Express | MongoDB | AWS",
    description:
      "A REST API and web scraper project written using the NodeJS runtime along with the express framework for gathering data on current and past MMA fighers and making them accessible via public endpoints from an EC2 container.",
    projectMedia: [MMAThumbnail],
    github: "https://github.com/FelixVaughan/UFC-FIGHTER-API",
    bgcolor: "rgba(255, 255, 255, 0.75)",
    id: "3",
  },
  {
    title: "Youtube Captions Extension",
    image: CaptionsThumbnail,
    technologies: "JavaScript | Bash | NodeJS | AWS | HTML | CSS",
    description:
      "Allows users to search and jump to locations in YouTube videos based off of subtitle timestamps. Search available in multiple languages.",
    projectMedia: [
      CaptionsDemo,
      CaptionsDemo2,
      CaptionsDemo3,
      CaptionsThumbnail,
      CaptionsThumbnail2,
      CaptionsThumbnail3,
      CaptionsThumbnail4,
      CaptionsThumbnail5,
    ],
    github: "https://github.com/FelixVaughan/youtube-captions-search",
    bgcolor: "rgba(255, 255, 255, 0.75)",
    id: "4",
  },
  {
    title: "Replstash",
    image: ReplstashThumbnail,
    technologies: "Typescript | Debug Adapter Protocol | VSCode Extension API",
    description:
      "A Visual Studio Code extension to quickly save, edit and rerun REPL content captured on breakpoints from the debug console.",
    projectMedia: [
      ReplstashDemo,
      ReplstashDemo2,
      ReplstashThumbnail,
      ReplstashThumbnail2,
      ReplstashThumbnail3,
      ReplstashThumbnail4,
      ReplstashThumbnail5,
      ReplstashThumbnail6,
    ],
    github: "https://github.com/FelixVaughan/Replstash",
    bgcolor: "rgba(255, 255, 255, 0.75)",
    id: "4",
  },
];
